import { ModalAccordion } from "@/components/Accordion";
import { Accordion, Flex, Image, Text } from "@chakra-ui/react";

export function UtqgModal() {
  return (
    <Accordion defaultIndex={[0]}>
      <ModalAccordion title="DURABILIDADE (TREADWEAR)">
        <Text textStyle="Regular" fontSize={{ base: "text3", lg: "text1" }} mb="10px">
          O índice Treadwear informa a resistência ao desgaste de um pneu quando comparado a outro.
          Este índice obtem-se mediante um teste efetuado em pista sobre uma distância de 9600 km,
          em condições controladas. Este índice pode ser desde 60 até 800. Um pneu com Treadwear
          igual a 200 desgastar-se-á 33% mais rápido que um pneu de 300, enquanto que um pneu com
          Treadwear igual a 420 irá durar 40% vezes mais que o de 300.
        </Text>
        <Text fontSize={{ base: "text3", lg: "text1" }} textStyle="Bold">
          Conclusão: Quanto mais elevado for o índice Treadwear, maior será a quilometragem que o
          pneu irá suportar.
        </Text>
        <Flex width="full" mt="10px" mr="10px" bgColor="#FFF5E5" p="5px 10px" alignItems="center">
          <Image
            src="https://cdn.pneufree.com.br/LINGLONG/images/Site/icons/geral/Warning.svg"
            w="20%"
            alt="Alerta"
            mr="5px"
          />
          <Text textStyle="Regular" fontSize={{ base: "text3", lg: "text1" }} alignItems="justify">
            Para obter máxima quilometragem de um pneu, é essencial que o mesmo esteja com a
            calibragem exata (a pressão ideal consta no manual do proprietário), que o carro esteja
            alinhado e com o conjunto pneu/roda balanceados. Também o modo de condução, temperatura
            ambiente, tipo de pavimento e outros fatores contribuem para aumentar ou diminuir a
            durabilidade de um pneu.
          </Text>
        </Flex>
      </ModalAccordion>
      <ModalAccordion title="ADERÊNCIA (TRACTION)">
        <Text fontSize="text1" textStyle="Bold" mb="10px">
          ADERÊNCIA (TRACTION)
        </Text>
        <Text textStyle="Regular" fontSize={{ base: "text3", lg: "text1" }} mb="10px">
          O índice Traction corresponde à aderência de um pneu em pista molhada. Ele é obtido em
          teste de frenagem na pista molhada, em linha reta, sob condições controladas. Este índice
          é expressado com as letras AA (índice mais elevado), A, B e C (índices mais baixos). O
          índice C é o mínimo aceitável.
        </Text>
        <Text textStyle="Regular" fontSize={{ base: "text3", lg: "text1" }} mb="10px">
          Embora esse teste seja parecido com o teste que é feito na etiquetagem do Inmetro, os
          parâmetros do ensaio são diferentes, pois eles são estabelecidos pelo Departamento de
          Transportes Americano (DOT).
        </Text>
        <Text fontSize={{ base: "text3", lg: "text1" }} textStyle="Bold">
          Conclusão: Um pneu de índice Traction AA terá maior aderência à pista e precisará de menor
          distância para parar o carro em pista molhada que um de índice A, e assim sucessivamente..
        </Text>
        <Flex width="auto" mt="10px" mr="10px" bgColor="#FFF5E5" p="5px 10px" alignItems="center">
          <Image
            src="https://cdn.pneufree.com.br/LINGLONG/images/Site/icons/geral/Warning.svg"
            alt="Alerta"
            w="10%"
            mr="5px"
          />
          <Text textStyle="Regular" fontSize={{ base: "text3", lg: "text1" }}>
            Dirija com muito cuidado em pista molhada, diminuindo a velocidade. Além da água,
            fatores como óleo na pista e sujeira podem tirar completamente a aderência pneu/solo.
          </Text>
        </Flex>
      </ModalAccordion>
      <ModalAccordion title="RESISTÊNCIA AO AQUECIMENTO (TEMPERATURE)">
        <Text fontSize={{ base: "text3", lg: "text1" }} textStyle="Bold" mb="10px">
          RESISTÊNCIA AO AQUECIMENTO (TEMPERATURE)
        </Text>
        <Text textStyle="Regular" fontSize={{ base: "text3", lg: "text1" }} mb="10px">
          O índice Temperature corresponde à resistência do pneu ao aquecimento e à sua capacidade
          de dissipar o calor. Este índice é obtido mediante um teste em laboratório simulando o uso
          nas ruas e estradas, e mede a capacidade de um pneu de dissipar o calor gerado pelo
          atrito. O excesso de calor pode provocar a degradação do pneu. Este índice é expresso
          pelas letras A (índice mais elevado), B e C (índices mais baixos).
        </Text>
        <Text fontSize={{ base: "text3", lg: "text1" }} textStyle="Bold">
          Conclusão: Um índice de temperatura elevado significa que o pneu resiste ao aquecimento e
          ao calor.
        </Text>
        <Flex width="auto" mt="10px" mr="10px" bgColor="#FFF5E5" p="5px 10px" alignItems="center">
          <Image
            src="https://cdn.pneufree.com.br/LINGLONG/images/Site/icons/geral/Warning.svg"
            alt="Alerta"
            w="15%"
            mr="5px"
          />
          <Text textStyle="Regular" fontSize={{ base: "text3", lg: "text1" }}>
            Para manter a temperatura correta de um pneu, é essencial que o mesmo esteja com a
            calibragem exata e que o veículo não sofra sobrecarga (pressão ideal e capacidade de
            carga do veículo constam no manual do proprietário).
          </Text>
        </Flex>
      </ModalAccordion>
    </Accordion>
  );
}
